let stores01 = [
    {
        storeNumber: "AU-R-000110",
        name: "3Fifteen Ann Arbor - AU",
        url: "https://weedmaps.com/dispensaries/ann-arbor-healing/menu/iverson-01-preroll",
        id: "AU-R-000110",
        phoneNumber: "",
        coordinates: {
            latitude: 42.254874,
            longitude: -83.687472,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "3720 Washtenaw Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48104,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48104,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3720 Washtenaw Ave", "Ann Arbor, MI 48104"],
    },
    {
        storeNumber: "PC-000344",
        name: "3Fifteen Ann Arbor - Med",
        url: "https://weedmaps.com/dispensaries/ann-arbor-healing/menu/iverson-01-preroll",
        id: "PC-000344",
        phoneNumber: "",
        coordinates: {
            latitude: 42.254874,
            longitude: -83.687472,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "3720 Washtenaw Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48104,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48104,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3720 Washtenaw Ave", "Ann Arbor, MI 48104"],
    },
    {
        storeNumber: "PC-000099",
        name: "3Fifteen Detroit 8 Mile and Hoover",
        url: "https://weedmaps.com/dispensaries/detroit-dispensing-company/menu/iverson-01-prepack",
        id: "PC-000099",
        phoneNumber: "",
        coordinates: {
            latitude: 42.448438,
            longitude: -83.004191,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "20580 Hoover",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48205,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48205,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["20580 Hoover", "Detroit, MI 48205"],
    },
    {
        storeNumber: "PC-000098",
        name: "3Fifteen Detroit 8 Mile and Lasher",
        url: "",
        id: "PC-000098",
        phoneNumber: "",
        coordinates: {
            latitude: 42.443038,
            longitude: -83.252051,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "21221 8 Mile RD",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48219,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48219,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["21221 8 Mile RD", "Detroit, MI 48219"],
    },
    {
        storeNumber: "PC-000100",
        name: "3Fifteen Detroit 8 Mile-Gratiot",
        url: "",
        id: "PC-000100",
        phoneNumber: "",
        coordinates: {
            latitude: 42.449761,
            longitude: -82.965101,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "15308 E 8 Mile Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48205,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48205,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["15308 E 8 Mile Rd", "Detroit, MI 48205"],
    },
    {
        storeNumber: "AU-R-000430",
        name: "3Fifteen-Camden",
        url: "https://weedmaps.com/dispensaries/3fifteen-camden-4/menu/iverson-01-prepack",
        id: "AU-R-000430",
        phoneNumber: "",
        coordinates: {
            latitude: 41.755711,
            longitude: -84.757721,
        },
        address: {
            city: "Camden",
            streetAddressLine1: "120 N. Main St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49232,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49232,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["120 N. Main St", "Camden, MI 49232"],
    },
    {
        storeNumber: "AU-R-000105",
        name: "3Fifteen-Columbia Battle Creek",
        url: "",
        id: "AU-R-000105",
        phoneNumber: "",
        coordinates: {
            latitude: 42.297181,
            longitude: -85.239879,
        },
        address: {
            city: "Battle Creek",
            streetAddressLine1: "2245 West Columbia Ave Suite 118",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49015,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49015,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2245 West Columbia Ave Suite 118", "Battle Creek, MI 49015"],
    },
    {
        storeNumber: "AU-R-000357",
        name: "3Fifteen-Division",
        url: "https://weedmaps.com/dispensaries/3fifteen-grand-rapids/menu/iverson-01-preroll",
        id: "AU-R-000357",
        phoneNumber: "",
        coordinates: {
            latitude: 42.910886,
            longitude: -85.665391,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "2900 Division Ave S",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49548,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49548,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2900 Division Ave S", "Grand Rapids, MI 49548"],
    },
    {
        storeNumber: "PC-000331",
        name: "3Fifteen-Flint",
        url: "",
        id: "PC-000331",
        phoneNumber: "",
        coordinates: {
            latitude: 43.002174,
            longitude: -83.731542,
        },
        address: {
            city: "Flint",
            streetAddressLine1: "3401 Corunna Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48083,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48083,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3401 Corunna Rd", "Flint, MI 48083"],
    },
    {
        storeNumber: "AU-R-000358",
        name: "3Fifteen-GR Plainfield",
        url: "https://weedmaps.com/dispensaries/3fifteen-grand-rapids-plainfield/menu/iverson-01-preroll",
        id: "AU-R-000358",
        phoneNumber: "",
        coordinates: {
            latitude: 43.024833,
            longitude: -85.633157,
        },
        address: {
            city: "Grand Rapids,",
            streetAddressLine1: "3423 NE Plainfield AVE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49525,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49525,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3423 NE Plainfield AVE", "Grand Rapids,, MI 49525"],
    },
    {
        storeNumber: "PC-000431",
        name: "3Fifteen-Grand Rapids-Division",
        url: "https://weedmaps.com/dispensaries/3fifteen-grand-rapids-plainfield/menu/iverson-01-preroll",
        id: "PC-000431",
        phoneNumber: "",
        coordinates: {
            latitude: 42.910886,
            longitude: -85.665391,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "2900 South Division AVE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49548,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49548,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2900 South Division AVE", "Grand Rapids, MI 49548"],
    },
    {
        storeNumber: "PC-000428",
        name: "3Fifteen-Grand Rapids-Plainfield",
        url: "https://weedmaps.com/dispensaries/3fifteen-grand-rapids-plainfield-recreational/menu/iverson-01-prepack",
        id: "PC-000428",
        phoneNumber: "",
        coordinates: {
            latitude: 43.024833,
            longitude: -85.633157,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "3423 NE Plainfield AVE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49525,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49525,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3423 NE Plainfield AVE", "Grand Rapids, MI 49525"],
    },
    {
        storeNumber: "AU-R-000389",
        name: "3Fifteen-Hamtramck",
        url: "",
        id: "AU-R-000389",
        phoneNumber: "",
        coordinates: {
            latitude: 42.403048,
            longitude: -83.06268,
        },
        address: {
            city: "hamtramck",
            streetAddressLine1: "11815 Joseph Campau ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48212,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48212,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["11815 Joseph Campau ave", "hamtramck, MI 48212"],
    },
    {
        storeNumber: "AU-R-000112",
        name: "3Fifteen-Michigan Battle Creek",
        url: "",
        id: "AU-R-000112",
        phoneNumber: "",
        coordinates: {
            latitude: 42.359712,
            longitude: -85.276993,
        },
        address: {
            city: "Battle Creek",
            streetAddressLine1: "1525 West Michigan Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49037,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49037,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1525 West Michigan Ave", "Battle Creek, MI 49037"],
    },
    {
        storeNumber: "AU-R-000168",
        name: "3Fifteen-Morenci",
        url: "",
        id: "AU-R-000168",
        phoneNumber: "",
        coordinates: {
            latitude: 41.717934,
            longitude: -84.203863,
        },
        address: {
            city: "Morenci",
            streetAddressLine1: "1050 E Main st",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49256,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49256,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1050 E Main st", "Morenci, MI 49256"],
    },
    {
        storeNumber: "PC-000370",
        name: "3fifteen-Morenci Med",
        url: "https://weedmaps.com/dispensaries/3fifteen-morenci/menu/iverson-01-prepack",
        id: "PC-000370",
        phoneNumber: "",
        coordinates: {
            latitude: 41.717934,
            longitude: -84.203863,
        },
        address: {
            city: "Morenci",
            streetAddressLine1: "1050 E Main st",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49256,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49256,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1050 E Main st", "Morenci, MI 49256"],
    },
    {
        storeNumber: "AU-R-000272",
        name: "AU: Compassionate Care By Design - Kalamazoo",
        url: "",
        id: "AU-R-000272",
        phoneNumber: "",
        coordinates: {
            latitude: 42.295533,
            longitude: -85.643479,
        },
        address: {
            city: "KALAMAZOO",
            streetAddressLine1: "401 N. Sage St.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49006,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49006,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["401 N. Sage St.", "KALAMAZOO, MI 49006"],
    },
    {
        storeNumber: "PC-000586",
        name: "Bazonzoes",
        url: "",
        id: "PC-000586",
        phoneNumber: "",
        coordinates: {
            latitude: 42.539478,
            longitude: -83.46637,
        },
        address: {
            city: "Walled Lake",
            streetAddressLine1: "1760 E. West Maple Road",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48390,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48390,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1760 E. West Maple Road", "Walled Lake, MI 48390"],
    },
    {
        storeNumber: "AU-R-000394",
        name: "Bazonzoes AU",
        url: "",
        id: "AU-R-000394",
        phoneNumber: "",
        coordinates: {
            latitude: 42.539478,
            longitude: -83.46637,
        },
        address: {
            city: "Walled Lake",
            streetAddressLine1: "1760 E. West Maple Road",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48390,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48390,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1760 E. West Maple Road", "Walled Lake, MI 48390"],
    },
    {
        storeNumber: "PC-000440",
        name: "Bazonzoes Provisioning Center - Med",
        url: "",
        id: "PC-000440",
        phoneNumber: "",
        coordinates: {
            latitude: 42.747535,
            longitude: -84.578953,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "2101 West Willow St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48917,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48917,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2101 West Willow St", "Lansing, MI 48917"],
    },
    {
        storeNumber: "AU-R-000426",
        name: "Bud Express",
        url: "",
        id: "AU-R-000426",
        phoneNumber: "",
        coordinates: {
            latitude: 41.911696,
            longitude: -86.001929,
        },
        address: {
            city: "Cassopolis",
            streetAddressLine1: "901 E State Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49031,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49031,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["901 E State Street", "Cassopolis, MI 49031"],
    },
    {
        storeNumber: "AU-R-000236",
        name: "CannaVista Wellness - AU",
        url: "",
        id: "AU-R-000236",
        phoneNumber: "",
        coordinates: {
            latitude: 41.827205,
            longitude: -86.360753,
        },
        address: {
            city: "Buchanan",
            streetAddressLine1: "120 E. Front St.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49107,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49107,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["120 E. Front St.", "Buchanan, MI 49107"],
    },
    {
        storeNumber: "PC-000377",
        name: "CannaVista Wellness - Med",
        url: "",
        id: "PC-000377",
        phoneNumber: "",
        coordinates: {
            latitude: 41.827205,
            longitude: -86.360753,
        },
        address: {
            city: "Buchanan",
            streetAddressLine1: "120 E. Front St.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49107,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49107,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["120 E. Front St.", "Buchanan, MI 49107"],
    },
    {
        storeNumber: "PC000397",
        name: "Compassionate Care By Design",
        url: "",
        id: "PC000397",
        phoneNumber: "",
        coordinates: {
            latitude: 42.295533,
            longitude: -85.643479,
        },
        address: {
            city: "Kalamazoo",
            streetAddressLine1: "401 N. Sage St.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49006,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49006,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["401 N. Sage St.", "Kalamazoo, MI 49006"],
    },
    {
        storeNumber: "PC-000642",
        name: "Crucial Cannabis",
        url: "",
        id: "PC-000642",
        phoneNumber: "",
        coordinates: {
            latitude: 42.460419,
            longitude: -83.125036,
        },
        address: {
            city: "Ferndale",
            streetAddressLine1: "642 E. 9 Mile RD",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48220,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48220,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["642 E. 9 Mile RD", "Ferndale, MI 48220"],
    },
    {
        storeNumber: "PC-000155",
        name: "Detroit Herbal Center",
        url: "",
        id: "PC-000155",
        phoneNumber: "",
        coordinates: {
            latitude: 42.393652,
            longitude: -83.159427,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "14325 Wyoming ST",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48238,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48238,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["14325 Wyoming ST", "Detroit, MI 48238"],
    },
    {
        storeNumber: "AU-R-000261",
        name: "Doja of Portage",
        url: "",
        id: "AU-R-000261",
        phoneNumber: "",
        coordinates: {
            latitude: 42.201228,
            longitude: -85.539519,
        },
        address: {
            city: "Portage",
            streetAddressLine1: "4203 E Centre AVE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49002,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49002,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["4203 E Centre AVE", "Portage, MI 49002"],
    },
    {
        storeNumber: "AU-R-000348",
        name: "Edgewood Cannabis - AU",
        url: "",
        id: "AU-R-000348",
        phoneNumber: "",
        coordinates: {
            latitude: 42.661234,
            longitude: -84.552283,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "134 E. Edgewood BLVD",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48911,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48911,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["134 E. Edgewood BLVD", "Lansing, MI 48911"],
    },
    {
        storeNumber: "AU-R-000551",
        name: "Elite Wellness - Bangor",
        url: "",
        id: "AU-R-000551",
        phoneNumber: "",
        coordinates: {
            latitude: 43.641457,
            longitude: -83.930632,
        },
        address: {
            city: "Bay City",
            streetAddressLine1: "3389 s huron road",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48706,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48706,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3389 s huron road", "Bay City, MI 48706"],
    },
    {
        storeNumber: "AU-R-000282",
        name: "Elite Wellness Jackson",
        url: "",
        id: "AU-R-000282",
        phoneNumber: "",
        coordinates: {
            latitude: 42.277016,
            longitude: -84.307738,
        },
        address: {
            city: "Jackson",
            streetAddressLine1: "6031 Ann Arbor road",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48382,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48382,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["6031 Ann Arbor road", "Jackson, MI 48382"],
    },
    {
        storeNumber: "AU-R-000103",
        name: "Elite Wellness Mt Morris",
        url: "",
        id: "AU-R-000103",
        phoneNumber: "",
        coordinates: {
            latitude: 43.144757,
            longitude: -83.690085,
        },
        address: {
            city: "MT MORRIS",
            streetAddressLine1: "9423 N DORT HWY",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48458,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48458,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["9423 N DORT HWY", "MT MORRIS, MI 48458"],
    },
    {
        storeNumber: "PC-000064",
        name: "Exclusive Brands - Med",
        url: "",
        id: "PC-000064",
        phoneNumber: "",
        coordinates: {
            latitude: 42.232044,
            longitude: -83.726515,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "3820 Varsity Drive",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48108,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48108,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3820 Varsity Drive", "Ann Arbor, MI 48108"],
    },
    {
        storeNumber: "AU-R-000100",
        name: "Exclusive Brands - Rec",
        url: "",
        id: "AU-R-000100",
        phoneNumber: "",
        coordinates: {
            latitude: 42.232044,
            longitude: -83.726515,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "3820 Varsity Drive",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48108,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48108,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3820 Varsity Drive", "Ann Arbor, MI 48108"],
    },
    {
        storeNumber: "PC-000568",
        name: "Exclusive Grand Rapids - Med",
        url: "",
        id: "PC-000568",
        phoneNumber: "",
        coordinates: {
            latitude: 42.909272,
            longitude: -85.609233,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "2350 29th Street SE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49508,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49508,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2350 29th Street SE", "Grand Rapids, MI 49508"],
    },
    {
        storeNumber: "AU-R-000370",
        name: "Exclusive Grand Rapids - Rec",
        url: "",
        id: "AU-R-000370",
        phoneNumber: "",
        coordinates: {
            latitude: 42.909272,
            longitude: -85.609233,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "2350 29th Street SE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49508,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49508,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2350 29th Street SE", "Grand Rapids, MI 49508"],
    },
    {
        storeNumber: "AU-R-000289",
        name: "Exclusive KZoo - AU",
        url: "",
        id: "AU-R-000289",
        phoneNumber: "",
        coordinates: {
            latitude: 42.281735,
            longitude: -85.53324,
        },
        address: {
            city: "Kalamazoo",
            streetAddressLine1: "937 Foster Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49048,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49048,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["937 Foster Ave", "Kalamazoo, MI 49048"],
    },
    {
        storeNumber: "AU-R-000320",
        name: "First Class - AU",
        url: "",
        id: "AU-R-000320",
        phoneNumber: "",
        coordinates: {
            latitude: 42.759597,
            longitude: -84.566868,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "2515 Grand River Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48906,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48906,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2515 Grand River Ave", "Lansing, MI 48906"],
    },
    {
        storeNumber: "PC-000465",
        name: "First Class - Med",
        url: "",
        id: "PC-000465",
        phoneNumber: "",
        coordinates: {
            latitude: 42.759597,
            longitude: -84.566868,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "2515 Grand River Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48906,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48906,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2515 Grand River Ave", "Lansing, MI 48906"],
    },
    {
        storeNumber: "AU-R-000401",
        name: "Freshwater Cannabis Co. - AU",
        url: "",
        id: "AU-R-000401",
        phoneNumber: "",
        coordinates: {
            latitude: 46.463031,
            longitude: -84.376695,
        },
        address: {
            city: "Sault Sainte Marie",
            streetAddressLine1: "3398 I75 Business Spur",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49783,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49783,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3398 I75 Business Spur", "Sault Sainte Marie, MI 49783"],
    },
    {
        storeNumber: "AU-R-000176",
        name: "From The Earth - AU",
        url: "",
        id: "AU-R-000176",
        phoneNumber: "",
        coordinates: {
            latitude: 42.085712,
            longitude: -84.641871,
        },
        address: {
            city: "Hanover",
            streetAddressLine1: "11990 Pulaski Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49241,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49241,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["11990 Pulaski Rd", "Hanover, MI 49241"],
    },
    {
        storeNumber: "AU-R-000210",
        name: "Green Koi - AU",
        url: "",
        id: "AU-R-000210",
        phoneNumber: "",
        coordinates: {
            latitude: 42.637049,
            longitude: -86.211136,
        },
        address: {
            city: "Douglas",
            streetAddressLine1: "435 Blue Star HWY",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49406,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49406,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["435 Blue Star HWY", "Douglas, MI 49406"],
    },
    {
        storeNumber: "AU-R-000624",
        name: "Green Pharm",
        url: "",
        id: "AU-R-000624",
        phoneNumber: "",
        coordinates: {
            latitude: 42.46129,
            longitude: -83.097541,
        },
        address: {
            city: "Hazel Park",
            streetAddressLine1: "812 E Nine Mile Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48030,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48030,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["812 E Nine Mile Rd", "Hazel Park, MI 48030"],
    },
    {
        storeNumber: "PC-000125",
        name: "Green Pharm - Detroit",
        url: "",
        id: "PC-000125",
        phoneNumber: "",
        coordinates: {
            latitude: 42.275439,
            longitude: -83.146353,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "2619 South Schaefer Highway",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48217,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48217,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2619 South Schaefer Highway", "Detroit, MI 48217"],
    },
    {
        storeNumber: "AU-R-000205",
        name: "Green Stem Provisioning - AU",
        url: "",
        id: "AU-R-000205",
        phoneNumber: "",
        coordinates: {
            latitude: 41.816553,
            longitude: -86.247878,
        },
        address: {
            city: "Niles",
            streetAddressLine1: "1140 S. 11th St.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49120,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49120,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1140 S. 11th St.", "Niles, MI 49120"],
    },
    {
        storeNumber: "AU-R-000163",
        name: "Green Tree Relief - Rec",
        url: "",
        id: "AU-R-000163",
        phoneNumber: "",
        coordinates: {
            latitude: 41.839445,
            longitude: -84.748007,
        },
        address: {
            city: "Reading",
            streetAddressLine1: "124 S Main St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49274,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49274,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["124 S Main St", "Reading, MI 49274"],
    },
    {
        storeNumber: "PC-000265",
        name: "Herbology",
        url: "",
        id: "PC-000265",
        phoneNumber: "",
        coordinates: {
            latitude: 42.282237,
            longitude: -83.785292,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "2730 Jackson Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48103,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48103,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2730 Jackson Ave", "Ann Arbor, MI 48103"],
    },
    {
        storeNumber: "AU-R-000252",
        name: "Herbology - Battle Creek",
        url: "",
        id: "AU-R-000252",
        phoneNumber: "",
        coordinates: {
            latitude: 42.283073,
            longitude: -85.156933,
        },
        address: {
            city: "Battle Creek",
            streetAddressLine1: "14501 Beadle Lake Road",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49014,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49014,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["14501 Beadle Lake Road", "Battle Creek, MI 49014"],
    },
    {
        storeNumber: "AU-R-000201",
        name: "Herbology - Kalamazoo REC",
        url: "",
        id: "AU-R-000201",
        phoneNumber: "",
        coordinates: {
            latitude: 42.269625,
            longitude: -85.531005,
        },
        address: {
            city: "Kalamazoo",
            streetAddressLine1: "1986 S sprinkle Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49048,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49048,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1986 S sprinkle Rd", "Kalamazoo, MI 49048"],
    },
    {
        storeNumber: "AU-R-000154",
        name: "Herbology -Ann Arbor",
        url: "",
        id: "AU-R-000154",
        phoneNumber: "",
        coordinates: {
            latitude: 42.282271,
            longitude: -83.785336,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "2732 Jackson Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48103,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48103,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["2732 Jackson Ave", "Ann Arbor, MI 48103"],
    },
    {
        storeNumber: "AU-R-000169",
        name: "Herbology Bangor - AU",
        url: "",
        id: "AU-R-000169",
        phoneNumber: "",
        coordinates: {
            latitude: 42.31298,
            longitude: -86.111329,
        },
        address: {
            city: "Bangor",
            streetAddressLine1: "133 W. Monroe St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49013,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49013,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["133 W. Monroe St", "Bangor, MI 49013"],
    },
    {
        storeNumber: "AU-R-000126",
        name: "Herbology Cannabis Co - AU",
        url: "",
        id: "AU-R-000126",
        phoneNumber: "",
        coordinates: {
            latitude: 42.262278,
            longitude: -83.13752,
        },
        address: {
            city: "River Rouge",
            streetAddressLine1: "11392 West Jefferson Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48218,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48218,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["11392 West Jefferson Ave", "River Rouge, MI 48218"],
    },
    {
        storeNumber: "AU-R-000371",
        name: "Higher Love - Crystal Falls",
        url: "",
        id: "AU-R-000371",
        phoneNumber: "",
        coordinates: {
            latitude: 46.096974,
            longitude: -88.323613,
        },
        address: {
            city: "Crystal Falls",
            streetAddressLine1: "116 Superior Ave.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49920,
        },
        timeZoneInfo: {
            currentTimeOffset: -6,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49920,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["116 Superior Ave.", "Crystal Falls, MI 49920"],
    },
    {
        storeNumber: "AU-R-000553",
        name: "Higher Love - HOU",
        url: "",
        id: "AU-R-000553",
        phoneNumber: "",
        coordinates: {
            latitude: 47.088486,
            longitude: -88.515998,
        },
        address: {
            city: "Houghton",
            streetAddressLine1: "46479 US 41 Hwy.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49931,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49931,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["46479 US 41 Hwy.", "Houghton, MI 49931"],
    },
    {
        storeNumber: "AU-R-000649",
        name: "Higher Love - IRW",
        url: "",
        id: "AU-R-000649",
        phoneNumber: "",
        coordinates: {
            latitude: 46.463463,
            longitude: -90.155764,
        },
        address: {
            city: "Ironwood",
            streetAddressLine1: "824 E. Cloverland Drive",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49938,
        },
        timeZoneInfo: {
            currentTimeOffset: -6,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49938,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["824 E. Cloverland Drive", "Ironwood, MI 49938"],
    },
    {
        storeNumber: "AU-R-000407",
        name: "Higher Love - Marquette Rec",
        url: "",
        id: "AU-R-000407",
        phoneNumber: "",
        coordinates: {
            latitude: 46.543867,
            longitude: -87.398034,
        },
        address: {
            city: "Marquette",
            streetAddressLine1: "344 W. Washington St.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49855,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49855,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["344 W. Washington St.", "Marquette, MI 49855"],
    },
    {
        storeNumber: "AU-R-000445",
        name: "Higher Love -Munising",
        url: "",
        id: "AU-R-000445",
        phoneNumber: "",
        coordinates: {
            latitude: 46.410734,
            longitude: -86.6526,
        },
        address: {
            city: "Munising",
            streetAddressLine1: "220 E. Munising Ave.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49862,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49862,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["220 E. Munising Ave.", "Munising, MI 49862"],
    },
    {
        storeNumber: "AU-R-000473",
        name: "Jars Ann Arbor - Rec",
        url: "",
        id: "AU-R-000473",
        phoneNumber: "",
        coordinates: {
            latitude: 42.276329,
            longitude: -83.749327,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "450 S Main St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48104,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48104,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["450 S Main St", "Ann Arbor, MI 48104"],
    },
    {
        storeNumber: "AU-R-000536",
        name: "Jars Ann Arbor Packard",
        url: "",
        id: "AU-R-000536",
        phoneNumber: "",
        coordinates: {
            latitude: 42.245157,
            longitude: -83.702837,
        },
        address: {
            city: "ANN ARBOR",
            streetAddressLine1: "3005 Packard St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48108,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48108,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["3005 Packard St", "ANN ARBOR, MI 48108"],
    },
    {
        storeNumber: "PC-000394",
        name: "Jars Detroit East",
        url: "",
        id: "PC-000394",
        phoneNumber: "",
        coordinates: {
            latitude: 42.448369,
            longitude: -83.007132,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "11400 E 8 Mile Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48205,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48205,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["11400 E 8 Mile Rd", "Detroit, MI 48205"],
    },
    {
        storeNumber: "PC-000653",
        name: "Jars Grand Rapids - Med",
        url: "",
        id: "PC-000653",
        phoneNumber: "",
        coordinates: {
            latitude: 42.996609,
            longitude: -85.688781,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "1815 Alpine Ave NW",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49504,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49504,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1815 Alpine Ave NW", "Grand Rapids, MI 49504"],
    },
    {
        storeNumber: "AU-R-000495",
        name: "Jars Grand Rapids - Rec",
        url: "",
        id: "AU-R-000495",
        phoneNumber: "",
        coordinates: {
            latitude: 42.996609,
            longitude: -85.688781,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "1815 Alpine Ave NW",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49504,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49504,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1815 Alpine Ave NW", "Grand Rapids, MI 49504"],
    },
    {
        storeNumber: "AU-R-000312",
        name: "Jars Mount Pleasant (AU)",
        url: "",
        id: "AU-R-000312",
        phoneNumber: "",
        coordinates: {
            latitude: 43.615653,
            longitude: -84.764469,
        },
        address: {
            city: "Mt. Pleasant",
            streetAddressLine1: "1005 Corporate Dr.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48858,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48858,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["1005 Corporate Dr.", "Mt. Pleasant, MI 48858"],
    },
    {
        storeNumber: "AU-R-000488",
        name: "Jars Mt Morris - Rec",
        url: "",
        id: "AU-R-000488",
        phoneNumber: "",
        coordinates: {
            latitude: 43.060792,
            longitude: -83.76322,
        },
        address: {
            city: "Flint",
            streetAddressLine1: "4326 W Pierson RD",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48504,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48504,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["4326 W Pierson RD", "Flint, MI 48504"],
    },
    {
        storeNumber: "AU-R-000285",
        name: "Jars Owosso AU",
        url: "",
        id: "AU-R-000285",
        phoneNumber: "",
        coordinates: {
            latitude: 42.997507,
            longitude: -84.182642,
        },
        address: {
            city: "Owosso",
            streetAddressLine1: "901 W Main St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48867,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48867,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["901 W Main St", "Owosso, MI 48867"],
    },
    {
        storeNumber: "AU-R-000323",
        name: "Jars River Rouge AU",
        url: "",
        id: "AU-R-000323",
        phoneNumber: "",
        coordinates: {
            latitude: 42.263005,
            longitude: -83.137054,
        },
        address: {
            city: "River Rouge",
            streetAddressLine1: "11347 W Jefferson Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48218,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48218,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["11347 W Jefferson Ave", "River Rouge, MI 48218"],
    },
    {
        storeNumber: "PC-000590",
        name: "Jars West Detroit",
        url: "",
        id: "PC-000590",
        phoneNumber: "",
        coordinates: {
            latitude: 42.445722,
            longitude: -83.147498,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "7461 W 8 Mile Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48221,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48221,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["7461 W 8 Mile Rd", "Detroit, MI 48221"],
    },
    {
        storeNumber: "AU-R-000279",
        name: "Jars-Lansing AU",
        url: "",
        id: "AU-R-000279",
        phoneNumber: "",
        coordinates: {
            latitude: 42.655117,
            longitude: -84.532509,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "7045 S Cedar",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48911,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48911,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["7045 S Cedar", "Lansing, MI 48911"],
    },
    {
        storeNumber: "PC-000491",
        name: "King Of Budz",
        url: "",
        id: "PC-000491",
        phoneNumber: "",
        coordinates: {
            latitude: 42.399933,
            longitude: -83.000943,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "10457 Gratiot Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48213,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48213,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Detroit, MI 48213"],
    },
    {
        storeNumber: "AU-R-000190",
        name: "Kzoo Retailers - AU",
        url: "",
        id: "AU-R-000190",
        phoneNumber: "",
        coordinates: {
            latitude: 42.318041,
            longitude: -85.576388,
        },
        address: {
            city: "Kalamazo",
            streetAddressLine1: "521 E Mosel",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49004,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49004,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Kalamazo, MI 49004"],
    },
    {
        storeNumber: "PC-000400",
        name: "Lighthouse",
        url: "",
        id: "PC-000400",
        phoneNumber: "",
        coordinates: {
            latitude: 44.754928,
            longitude: -85.595662,
        },
        address: {
            city: "TRAVERSE CITY",
            streetAddressLine1: "704 S GARFIELD AVE.",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49686,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49686,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "TRAVERSE CITY, MI 49686"],
    },
    {
        storeNumber: "AU-R-000200",
        name: "Meds Cafe Lowell - AU",
        url: "",
        id: "AU-R-000200",
        phoneNumber: "",
        coordinates: {
            latitude: 42.93178,
            longitude: -85.359598,
        },
        address: {
            city: "Lowell",
            streetAddressLine1: "1965 W. Main Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49331,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49331,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Lowell, MI 49331"],
    },
    {
        storeNumber: "AU-R-000599",
        name: "Meds Café, Cedar Springs",
        url: "",
        id: "AU-R-000599",
        phoneNumber: "",
        coordinates: {
            latitude: 43.221954,
            longitude: -85.571244,
        },
        address: {
            city: "Cedar Springs",
            streetAddressLine1: "14111 White Creek Ave NE Suite H",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 59319,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 59319,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Cedar Springs, MI 59319"],
    },
    {
        storeNumber: "AU-R-000482",
        name: "Michigan Pure Green",
        url: "",
        id: "AU-R-000482",
        phoneNumber: "",
        coordinates: {
            latitude: 42.186043,
            longitude: -85.540379,
        },
        address: {
            city: "Portage",
            streetAddressLine1: "9007 S Sprinkle Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49002,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49002,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Portage, MI 49002"],
    },
    {
        storeNumber: "AU-R-000338",
        name: "Michigan Supply and Provisions - Grand Rapids - AU",
        url: "",
        id: "AU-R-000338",
        phoneNumber: "",
        coordinates: {
            latitude: 42.913288,
            longitude: -85.598147,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "2741 28th Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49546,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49546,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Grand Rapids, MI 49546"],
    },
    {
        storeNumber: "AU-R-000373",
        name: "Michigan Supply and Provisions - Grand Rapids AU",
        url: "",
        id: "AU-R-000373",
        phoneNumber: "",
        coordinates: {
            latitude: 42.987938,
            longitude: -85.675981,
        },
        address: {
            city: "Grand Rapids",
            streetAddressLine1: "1336 Scribner AVE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49504,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49504,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Grand Rapids, MI 49504"],
    },
    {
        storeNumber: "AU-R-000311",
        name: "Mint Cannabis",
        url: "",
        id: "AU-R-000311",
        phoneNumber: "",
        coordinates: {
            latitude: 42.259428,
            longitude: -85.572341,
        },
        address: {
            city: "KALAMAZOO",
            streetAddressLine1: "730 E CORK ST",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49001,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49001,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "KALAMAZOO, MI 49001"],
    },
    {
        storeNumber: "PC-000123",
        name: "Mission Ann Arbor",
        url: "",
        id: "PC-000123",
        phoneNumber: "",
        coordinates: {
            latitude: 42.280901,
            longitude: -83.748162,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "111 S Main Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48104,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48104,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Ann Arbor, MI 48104"],
    },
    {
        storeNumber: "AU-R-000133",
        name: "Mission Ann Arbor - AU",
        url: "",
        id: "AU-R-000133",
        phoneNumber: "",
        coordinates: {
            latitude: 42.280901,
            longitude: -83.748162,
        },
        address: {
            city: "Ann Arbor",
            streetAddressLine1: "111 S. Main Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48104,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48104,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Ann Arbor, MI 48104"],
    },
    {
        storeNumber: "AU-R-000508",
        name: "Oz Cannabis Owosso AU",
        url: "",
        id: "AU-R-000508",
        phoneNumber: "",
        coordinates: {
            latitude: 42.997651,
            longitude: -84.169535,
        },
        address: {
            city: "Owosso",
            streetAddressLine1: "117 E Main Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48867,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48867,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Owosso, MI 48867"],
    },
    {
        storeNumber: "PC-000640",
        name: "Oz Cannabis Owosso MED",
        url: "",
        id: "PC-000640",
        phoneNumber: "",
        coordinates: {
            latitude: 42.997651,
            longitude: -84.169535,
        },
        address: {
            city: "Owosso",
            streetAddressLine1: "117 E Main Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48867,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48867,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Owosso, MI 48867"],
    },
    {
        storeNumber: "PC-000205",
        name: "PCO - Five & Dime",
        url: "",
        id: "PC-000205",
        phoneNumber: "",
        coordinates: {
            latitude: 42.446771,
            longitude: -83.042062,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "20561 Dwyer St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48234,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48234,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Detroit, MI 48234"],
    },
    {
        storeNumber: "PC-000259",
        name: "PCO - Motown Meds",
        url: "",
        id: "PC-000259",
        phoneNumber: "",
        coordinates: {
            latitude: 42.343494,
            longitude: -83.218678,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "18334 W Warren Avenue",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48228,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48228,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Detroit, MI 48228"],
    },
    {
        storeNumber: "PC-000260",
        name: "PCO - Remedii Stateline",
        url: "",
        id: "PC-000260",
        phoneNumber: "",
        coordinates: {
            latitude: 41.718326,
            longitude: -84.204099,
        },
        address: {
            city: "Morenci",
            streetAddressLine1: "989 E. Main St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49256,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49256,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Morenci, MI 49256"],
    },
    {
        storeNumber: "PC-000226",
        name: "PCO - Shake & Bake",
        url: "",
        id: "PC-000226",
        phoneNumber: "",
        coordinates: {
            latitude: 42.443802,
            longitude: -83.181105,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "20477 schaefer hwy",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48235,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48235,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Detroit, MI 48235"],
    },
    {
        storeNumber: "AU-R-000547",
        name: "Premier Provisioning #3",
        url: "",
        id: "AU-R-000547",
        phoneNumber: "",
        coordinates: {
            latitude: 43.429161,
            longitude: -83.931143,
        },
        address: {
            city: "Saginaw",
            streetAddressLine1: "910 E Genesse Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48607,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48607,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Saginaw, MI 48607"],
    },
    {
        storeNumber: "PC-000534",
        name: "Premier Provisioning Center, LLC",
        url: "",
        id: "PC-000534",
        phoneNumber: "",
        coordinates: {
            latitude: 43.496548,
            longitude: -83.386851,
        },
        address: {
            city: "caro",
            streetAddressLine1: "1023 e caro",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48723,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48723,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "caro, MI 48723"],
    },
    {
        storeNumber: "AU-R-000198",
        name: "Pure Options - Eastside",
        url: "",
        id: "AU-R-000198",
        phoneNumber: "",
        coordinates: {
            latitude: 42.729739,
            longitude: -84.523384,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "1900 E Kalamazoo Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48912,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48912,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Lansing, MI 48912"],
    },
    {
        storeNumber: "AU-R-000506",
        name: "Pure Options - Frandor",
        url: "",
        id: "AU-R-000506",
        phoneNumber: "",
        coordinates: {
            latitude: 42.73452,
            longitude: -84.508761,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "125 N Clippert St",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48912,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48912,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Lansing, MI 48912"],
    },
    {
        storeNumber: "AU-R-000366",
        name: "Pure Options - Muskegon",
        url: "",
        id: "AU-R-000366",
        phoneNumber: "",
        coordinates: {
            latitude: 43.288453,
            longitude: -86.217647,
        },
        address: {
            city: "Muskegon",
            streetAddressLine1: "1965 Holton Road",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49445,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49445,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Muskegon, MI 49445"],
    },
    {
        storeNumber: "AU-R-000197",
        name: "Pure Options - North",
        url: "",
        id: "AU-R-000197",
        phoneNumber: "",
        coordinates: {
            latitude: 42.763548,
            longitude: -84.542918,
        },
        address: {
            city: "Lansing",
            streetAddressLine1: "2905 N East Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48906,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48906,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Lansing, MI 48906"],
    },
    {
        storeNumber: "PR-000194",
        name: "Pure X",
        url: "",
        id: "PR-000194",
        phoneNumber: "",
        coordinates: {
            latitude: 42.479117,
            longitude: -82.982299,
        },
        address: {
            city: "Warren",
            streetAddressLine1: "13951 E 10 Mile Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48089,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48089,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Warren, MI 48089"],
    },
    {
        storeNumber: "AU-P-000199",
        name: "Pure X, LLC",
        url: "",
        id: "AU-P-000199",
        phoneNumber: "",
        coordinates: {
            latitude: 42.479117,
            longitude: -82.982299,
        },
        address: {
            city: "Warren",
            streetAddressLine1: "13951 E 10 Mile Rd Suite B",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48089,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48089,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Warren, MI 48089"],
    },
    {
        storeNumber: "AU-P-000110",
        name: "Rair",
        url: "",
        id: "AU-P-000110",
        phoneNumber: "",
        coordinates: {
            latitude: 42.248583,
            longitude: -84.36478,
        },
        address: {
            city: "JACKSON",
            streetAddressLine1: "1225 S DETTMAN RD",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49203,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49203,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "JACKSON, MI 49203"],
    },
    {
        storeNumber: "AU-R-000193",
        name: "Remedii Battle Creek - AU",
        url: "",
        id: "AU-R-000193",
        phoneNumber: "",
        coordinates: {
            latitude: 42.298417,
            longitude: -85.193318,
        },
        address: {
            city: "Battle Creek",
            streetAddressLine1: "160 East Columbia Ave",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49015,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49015,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Battle Creek, MI 49015"],
    },
    {
        storeNumber: "AU-R-000392",
        name: "Shango",
        url: "",
        id: "AU-R-000392",
        phoneNumber: "",
        coordinates: {
            latitude: 42.460163,
            longitude: -83.106508,
        },
        address: {
            city: "Hazel Park",
            streetAddressLine1: "22821 S Chrysler dr",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48030,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48030,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Hazel Park, MI 48030"],
    },
    {
        storeNumber: "Pr-000172",
        name: "Shango - Hazel Park",
        url: "",
        id: "Pr-000172",
        phoneNumber: "",
        coordinates: {
            latitude: 42.447457,
            longitude: -83.108591,
        },
        address: {
            city: "Hazel Park",
            streetAddressLine1: "456 W 8 Mile Road",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48030,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48030,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Hazel Park, MI 48030"],
    },
    {
        storeNumber: "PR-000185",
        name: "Sozo Health",
        url: "",
        id: "PR-000185",
        phoneNumber: "",
        coordinates: {
            latitude: 42.469402,
            longitude: -83.006712,
        },
        address: {
            city: "Warren",
            streetAddressLine1: "23751 Hoover Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48089,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48089,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Warren, MI 48089"],
    },
    {
        storeNumber: "AU-R-000360",
        name: "Sozo Health - Cheboygan - Rec",
        url: "",
        id: "AU-R-000360",
        phoneNumber: "",
        coordinates: {
            latitude: 45.648123,
            longitude: -84.473591,
        },
        address: {
            city: "Cheboygan",
            streetAddressLine1: "100 N. Main Street",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49721,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49721,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Cheboygan, MI 49721"],
    },
    {
        storeNumber: "AU-R-000402",
        name: "Sozo Health - Muskegon - Rec",
        url: "",
        id: "AU-R-000402",
        phoneNumber: "",
        coordinates: {
            latitude: 43.213423,
            longitude: -86.258939,
        },
        address: {
            city: "Muskegon",
            streetAddressLine1: "580 W. Hackley AVE",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49444,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49444,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Muskegon, MI 49444"],
    },
    {
        storeNumber: "PC-000563",
        name: "The Remedy LLC",
        url: "",
        id: "PC-000563",
        phoneNumber: "",
        coordinates: {
            latitude: 42.443503,
            longitude: -83.240453,
        },
        address: {
            city: "Detroit",
            streetAddressLine1: "20041 Eight Mile Rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48219,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48219,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Detroit, MI 48219"],
    },
    {
        storeNumber: "AU-R-000184",
        name: "The Sweet Leaf - AU",
        url: "",
        id: "AU-R-000184",
        phoneNumber: "",
        coordinates: {
            latitude: 43.02344,
            longitude: -83.655371,
        },
        address: {
            city: "Flint",
            streetAddressLine1: "400 s dort hwy",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48503,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48503,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Flint, MI 48503"],
    },
    {
        storeNumber: "AU-R-000526",
        name: "True Leaf",
        url: "",
        id: "AU-R-000526",
        phoneNumber: "",
        coordinates: {
            latitude: 42.303748,
            longitude: -85.697876,
        },
        address: {
            city: "Lawrence",
            streetAddressLine1: "265 Crandall Parkway",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 49009,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 49009,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Lawrence, MI 49009"],
    },
    {
        storeNumber: "PC-000150",
        name: "Uncle Buds Provisioning Center",
        url: "",
        id: "PC-000150",
        phoneNumber: "",
        coordinates: {
            latitude: 43.737725,
            longitude: -83.976345,
        },
        address: {
            city: "Linwood",
            streetAddressLine1: "11 S Huron rd",
            streetAddressLine2: "",
            streetAddressLine3: "",
            countrySubdivisionCode: "MI",
            countryCode: "US",
            postalCode: 48634,
        },
        timeZoneInfo: {
            currentTimeOffset: -5,
            windowsTimeZoneId: "",
            olsonTimeZoneId: "",
        },
        brandName: 48634,
        ownershipTypeCode: "CO",
        open: "",
        openStatusText: "",
        addressLines: ["", "Linwood, MI 48634"],
    },
];